<template>
  <div class="d-flex flex-column overflow-hidden">
    <v-text-field
      v-model="search"
      variant="underlined"
      prepend-inner-icon="mdi-magnify"
      hide-details
      label="Search"
      class="ma-2"
      data-cy="character-search-input"
    ></v-text-field>
    <div class="overflow-y-auto" data-cy="character-list">
      <button
        v-for="character in filtered"
        :key="character.id"
        class="charButton"
        :data-cy="`character-button-${character.id}`"
        @click="$emit('select', character)"
      >
        <img
          :src="character.img.src"
          style="width: 32px; height: 32px"
          :data-cy="`character-image-${character.id}`"
        />
      </button>
    </div>
  </div>
</template>

<script>
import { useEventStore } from '../stores/event'

export default {
  emits: ['select'],
  setup() {
    let eventStore = useEventStore()
    return { eventStore }
  },
  data() {
    return {
      search: ''
    }
  },
  computed: {
    filtered() {
      // Ensure search is always a string before calling toLowerCase
      const searchTerm = (this.search || '').toLowerCase()
      return this.characters?.filter((character) =>
        character.name
          .normalize('NFD')
          .replace(/[^a-z]/gi, '')
          .toLowerCase()
          .includes(searchTerm)
      )
    },
    characters() {
      return this.eventStore.game.characters
    }
  }
}
</script>

<style>
.charButton {
  width: 36px;
  height: 36px;
  padding: 2px;
  border-radius: 4px;
}

.charButton:hover {
  background-color: rgba(211, 211, 211, 0.2);
}
</style>
